import gql from 'graphql-tag';
import { collectionObjectParameters } from './defaultObjectQuery';
import { fetchGraphQL } from 'lib/fetch-graphql';

const query = gql`
	query CustomQuery($accessionNumber: String!) {
		search(accessionNumber: $accessionNumber) {${collectionObjectParameters}}
	}
`;
export async function fetchObjectByAccessionNumber(accessionNumber: string) {
	const result = await fetchGraphQL({
		query: query,
		variables: { accessionNumber: accessionNumber },
		tags: [`crdAccessionNumber:${accessionNumber}`], //TODO figure out CRD tags
	});
	return result?.data?.search?.[0];
}
